export const GROWTH_CITATIONS_META = {
  eyebrow: 'SEO · Directory Listings',
  titleLead: 'Local',
  titleAccent: 'citations',
  description:
    'Your business listings across directories. ELVA monitors NAP consistency, auto-corrects mismatches, and surfaces missing or duplicate listings. Inconsistent NAP hurts Map Pack rankings — Google needs to trust you are who you say you are.',
} as const;
